/**
 * Extracts the filename from a Content-Disposition response header.
 * Supports both `filename="..."` and RFC 5987 `filename*=UTF-8''...`.
 * Returns `undefined` when the header is absent or unparseable.
 */
export function parseFilenameFromContentDisposition(
  header: string | null | undefined,
): string | undefined {
  if (!header) return undefined;

  const utf8Match = header.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ""));
    } catch {
      // fall through to plain filename below
    }
  }

  const plainMatch = header.match(/filename\s*=\s*("([^"]+)"|([^;]+))/i);
  const value = plainMatch?.[2] ?? plainMatch?.[3];
  return value?.trim() || undefined;
}
